import { Box, Divider, Group, Stack, Text, TextInput, Tooltip } from "@mantine/core";
import React from "react";
import { ISJArapport } from "@mcapps/shared/reportSchemas/sjaSchema";

export const INPUT_FLEX = 0.5;
const LABEL_WIDTH = 160;

const SJAGenerellInfo: React.FC<{
  editData: ISJArapport;
  updateData: (key: string, value: any) => void;
}> = ({ editData, updateData }) => {
  return (
    <Box w="50%">
      <Divider
        mb="sm"
        label={
          <Text fz="lg" fw={600}>
            Generelt
          </Text>
        }
        labelPosition="left"
      />
      <Stack>
        <Group>
          <Text w={LABEL_WIDTH}>SJA-tittel:</Text>
          <TextInput
            value={editData.generellInfo?.sjaTittel}
            onChange={(e) => updateData("generellInfo.sjaTittel", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH}>Oppdragsnavn:</Text>
          <TextInput
            value={editData.generellInfo?.oppdragsNavn}
            onChange={(e) => updateData("generellInfo.oppdragsNavn", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH}>Oppdragsnummer:</Text>
          <TextInput
            value={editData.generellInfo?.oppdragsNummer}
            onChange={(e) => updateData("generellInfo.oppdragsNummer", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH}>Beskrivelse av arbeidet:</Text>
          <TextInput
            value={editData.generellInfo?.beskrivelseAvArbeidet}
            onChange={(e) => updateData("generellInfo.beskrivelseAvArbeidet", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH}>Firma/avdeling/seksjon:</Text>
          <TextInput
            value={editData.generellInfo?.firmaAvdelingSeksjon}
            onChange={(e) => updateData("generellInfo.firmaAvdelingSeksjon", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Tooltip label="Hvilke forutsetninger ligger til grunn? Hva skal sjekkes?">
            <Text w={LABEL_WIDTH}>Forutsetninger:</Text>
          </Tooltip>
          <TextInput
            value={editData.generellInfo?.forutsetninger}
            onChange={(e) => updateData("generellInfo.forutsetninger", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Tooltip label="Hvem er ansvarlig for SJA-rapporten?">
            <Text w={LABEL_WIDTH}>SJA-koordinator:</Text>
          </Tooltip>
          <TextInput
            value={editData.generellInfo?.sjaKoordinator}
            onChange={(e) => updateData("generellInfo.sjaKoordinator", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Tooltip label="Hva går jobben som skal befares ut på?">
            <Text w={LABEL_WIDTH}>Jobboperasjon:</Text>
          </Tooltip>
          <TextInput
            value={editData.generellInfo?.jobbOperasjon}
            onChange={(e) => updateData("generellInfo.jobbOperasjon", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH}>Dato for befaring:</Text>
          <TextInput
            type="date"
            value={editData.generellInfo?.dato}
            onChange={(e) => updateData("generellInfo.dato", e.currentTarget.value)}
            size="sm"
            flex={INPUT_FLEX}
          />
        </Group>
      </Stack>
    </Box>
  );
};

export default SJAGenerellInfo;
